export default class pinnedNavComponent {
    constructor(el) {
        this.el = el;
    }

    addPinnedNav() {
        const pinnedNav = document.querySelector('#pinned-nav');
        const pinnedNavMob = document.querySelector("#pinned-nav-mob");
        const topNavHeight = document.querySelector('.top-nav-secondary').offsetHeight ;
        const topNavHeightMob = document.querySelector('#top-nav').offsetHeight ;
        const distanceFromTop = pinnedNav.getBoundingClientRect().top - pinnedNav.offsetHeight;
        const distanceFromTopMob = pinnedNavMob.getBoundingClientRect().top - pinnedNavMob.offsetHeight;

        let menuContainer = document.querySelector('.menu-container').offsetHeight;
        let scroll_position = 0, scroll_direction;
        
        const addStickyNav = function(scroll_direction){
            if ( scroll_direction === 'up' ) {
                pinnedNav.style.top = menuContainer - 10 + 'px';
                pinnedNavMob.style.top = topNavHeightMob + 'px';
            } else if (scroll_direction === 'down'){
                pinnedNav.style.top = topNavHeightMob - 10 + 'px';
            }
            if(window.innerWidth >= 576 && window.innerWidth <= 767)  pinnedNavMob.style.top = '88px';
            if(window.innerWidth >= 768 && window.innerWidth <= 991)  pinnedNavMob.style.top = '104px' ;
        }

        window.addEventListener('scroll', (e) => {
            let windowWidth = window.innerWidth;
            if (windowWidth > 990) {
                scroll_direction = (document.body.getBoundingClientRect()).top > scroll_position ? 'up' : 'down';
                scroll_position = (document.body.getBoundingClientRect()).top;
                addStickyNav(scroll_direction);
                if(window.scrollY > distanceFromTop){
                    pinnedNav.classList.add("nav-sticky");
                    pinnedNav.classList.remove("rbc-pinned");
                    pinnedNavMob.classList.add("nav-sticky");
                }
            } else {
                scroll_direction = (document.body.getBoundingClientRect()).top > scroll_position ? 'up' : 'down';
                scroll_position = (document.body.getBoundingClientRect()).top;
                addStickyNav(scroll_direction);
                if(window.scrollY > distanceFromTopMob){
                    pinnedNav.classList.remove("nav-sticky");
                    pinnedNav.classList.add("rbc-pinned");
                    pinnedNavMob.classList.remove("nav-sticky");
                }
            }
            if(window.pageYOffset < menuContainer){
                pinnedNav.classList.remove('nav-sticky');
                pinnedNav.classList.add("rbc-pinned");
                pinnedNavMob.classList.remove("nav-sticky");
            }
        })
    };

    init() {
        this.addPinnedNav();
    }
}

window.addEventListener('DOMContentLoaded', (event) => {
    const pinnedNav = document.querySelector('#pinned-nav');
    if(pinnedNav) {    
        new pinnedNavComponent(pinnedNav).init()
    }
});
window.addEventListener('resize', (event) => {
    const pinnedNav = document.querySelector('#pinned-nav');
    if(pinnedNav) {    
        new pinnedNavComponent(pinnedNav).init()
    }
});